"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _companyappApi = require("@/api/companyappApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MAX_COVER_SIZE = 100;
var MAX_COVER_SIZE_ERROR = '图片大小不能超过100KB';
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      detailInfo: {},
      handerOptions: [],
      checkboxGroup: [],
      appOptions: [],
      mode: 'add',
      form: {
        id: '',
        term: '',
        appScope: 0,
        appIds: [],
        status: 0,
        sort: 0,
        iconImg: '',
        attachmentId: '',
        source: ''
      },
      rules: {
        term: [{
          required: true,
          message: '请输入热搜词名称',
          trigger: 'blur'
        }, {
          max: 10,
          message: '热搜词名称不能超过10个字符',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择热搜词状态',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '排序不能为空',
          trigger: 'blur'
        }, {
          validator: this.validateSort,
          trigger: 'blur'
        }],
        appIds: [{
          validator: this.validateAppIds,
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.checkboxGroup = [];
  },
  computed: {
    isEdit: function isEdit() {
      return this.mode === 'edit';
    },
    dialogTitle: function dialogTitle() {
      return this.isEdit ? '编辑热搜词' : '新增热搜词';
    },
    sourceText: function sourceText() {
      var sourceMap = {
        1: '系统生成',
        2: '手动新增'
      };
      return sourceMap[this.form.source] || '--';
    }
  },
  methods: {
    initOpen: function initOpen() {
      var _this = this;
      var detailInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'add';
      this.mode = mode;
      this.form = {
        id: detailInfo.id || '',
        term: detailInfo.term || '',
        appScope: detailInfo.appScope !== undefined && detailInfo.appScope !== null ? detailInfo.appScope : 0,
        appIds: detailInfo.companyAppIds || [],
        status: detailInfo.status !== undefined && detailInfo.status !== null ? detailInfo.status : 0,
        sort: detailInfo.sort !== undefined && detailInfo.sort !== null ? detailInfo.sort : 0,
        iconImg: detailInfo.iconImg || '',
        attachmentId: '',
        source: detailInfo.source !== undefined && detailInfo.source !== null ? detailInfo.source : ''
      };
      this.getAppOptions();
      this.visible = true;
      this.$nextTick(function () {
        _this.$refs.form && _this.$refs.form.clearValidate();
      });
    },
    handerSubmit: function handerSubmit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var params = _this2.buildSubmitParams();
        if (_this2.isEdit) {
          _this2.submitSave(params, _marketing.searchTermUpdateApi, '编辑成功');
          return;
        }
        _this2.checkRepeatBeforeAdd(params);
      });
    },
    checkRepeatBeforeAdd: function checkRepeatBeforeAdd(params) {
      var _this3 = this;
      this.loading = true;
      (0, _marketing.searchTermCheckRepeatApi)(params).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (res.repeated) {
          _this3.loading = false;
          if (res.allRepeated) {
            _this3.$message.error("\u8BE5\u70ED\u641C\u8BCD\u5DF2\u5B58\u5728\u300C".concat(res.appNames || '', "\u300D\uFF0C\u4E0D\u5141\u8BB8\u521B\u5EFA\u91CD\u590D\u70ED\u641C\u8BCD"));
            return;
          }
          _this3.confirmRepeatAdd(params, res.appNames);
          return;
        }
        _this3.submitSave(params, _marketing.searchTermAddApi, '新增成功');
      }).catch(function () {
        _this3.loading = false;
      });
    },
    confirmRepeatAdd: function confirmRepeatAdd(params, appNames) {
      var _this4 = this;
      this.$confirm("\u8BE5\u70ED\u641C\u8BCD\u5DF2\u5B58\u5728\u300C".concat(appNames || '', "\u300D\uFF0C\u65B0\u589E\u540E\u8BE5\u5C0F\u7A0B\u5E8F\u4E0D\u5B58\u5728\u6B64\u70ED\u641C\u8BCD\uFF0C\u786E\u8BA4\u8981\u65B0\u589E\uFF1F"), '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.submitSave(params, _marketing.searchTermAddApi, '新增成功');
      }).catch(function () {});
    },
    submitSave: function submitSave(params, requestApi, successMsg) {
      var _this5 = this;
      this.loading = true;
      requestApi(params).then(function () {
        _this5.$message.success(successMsg);
        _this5.loading = false;
        _this5.visible = false;
        _this5.$emit('doRefresh');
      }).catch(function () {
        _this5.loading = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    buildSubmitParams: function buildSubmitParams() {
      var sort = Number(this.form.sort);
      if (this.isEdit) {
        var _params = {
          id: this.form.id,
          status: this.form.status,
          sort: sort
        };
        if (this.form.attachmentId) {
          _params.attachmentId = this.form.attachmentId;
        }
        return _params;
      }
      var params = {
        term: (this.form.term || '').trim(),
        appScope: this.form.appScope,
        status: this.form.status,
        sort: sort,
        attachmentId: this.form.attachmentId || null,
        companyAppIds: this.form.appScope === 1 ? this.form.appIds : []
      };
      return params;
    },
    validateSort: function validateSort(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('排序不能为空'));
        return;
      }
      if (!Number.isInteger(Number(value)) || Number(value) < 0) {
        callback(new Error('排序只能填写非负整数'));
        return;
      }
      if (Number(value) > 99999) {
        callback(new Error('排序最大99999'));
        return;
      }
      callback();
    },
    validateAppIds: function validateAppIds(rule, value, callback) {
      if (this.form.appScope === 1 && (!value || !value.length)) {
        callback(new Error('请选择小程序'));
        return;
      }
      callback();
    },
    getAppOptions: function getAppOptions() {
      var _this6 = this;
      (0, _companyappApi.companyappAutoListApi)().then(function (res) {
        _this6.appOptions = (res || []).map(function (item) {
          return {
            label: item.appName,
            value: item.id
          };
        });
      });
    },
    modalPicTap: function modalPicTap() {
      var _this7 = this;
      this.$modalUpload(function (res) {
        if (!res || !res[0]) return;
        var url = res[0].attDir || res[0].sattDir || res[0].url || '';
        if (!url) return;
        _this7.form.attachmentId = res[0].attId || res[0].id || '';
        _this7.form.iconImg = url;
        _this7.$refs.form && _this7.$refs.form.validateField('iconImg');
      }, '1', 'system', true, {
        maxSizeKB: MAX_COVER_SIZE,
        maxSizeErrorMsg: MAX_COVER_SIZE_ERROR
      });
    },
    removeCoverImg: function removeCoverImg() {
      this.form.iconImg = '';
      this.form.attachmentId = '';
      this.$refs.form && this.$refs.form.validateField('iconImg');
    }
  }
};